import { render, staticRenderFns } from "./ArrivalProgressBar.vue?vue&type=template&id=0b4c711e&scoped=true&"
import script from "./ArrivalProgressBar.vue?vue&type=script&lang=ts&"
export * from "./ArrivalProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./ArrivalProgressBar.vue?vue&type=style&index=0&id=0b4c711e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c711e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
